// const BASE_URL = 'https://saviagent.savictech.com/sks/grir/api/v1/grir';

// async function handleResponse(res) {
//   if (!res.ok) {
//     let detail = `HTTP ${res.status}`;
//     try {
//       const data = await res.json();
//       if (Array.isArray(data.detail)) {
//         detail = data.detail
//           .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' → ') : e.loc}] ${e.msg}`)
//           .join(' | ');
//       } else if (typeof data.detail === 'string') {
//         detail = data.detail;
//       } else {
//         detail = JSON.stringify(data);
//       }
//     } catch (_) {}
//     throw new Error(detail);
//   }
//   return res.json();
// }

// function buildQs(params = {}) {
//   const clean = Object.fromEntries(
//     Object.entries(params).filter(([, v]) => v !== '' && v !== undefined && v !== null)
//   );
//   const qs = new URLSearchParams(clean).toString();
//   return qs ? '?' + qs : '';
// }

// export const getDashboard = () =>
//   fetch(`${BASE_URL}/dashboard`).then(handleResponse);

// export const testSapConnection = () =>
//   fetch(`${BASE_URL}/sap/test-connection`).then(handleResponse);

// export const sapSync = (payload) =>
//   fetch(`${BASE_URL}/sap-sync`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload),
//   }).then(handleResponse);

// export const uploadGR = (files) => {
//   const formData = new FormData();
//   (Array.isArray(files) ? files : [files]).forEach((f) => formData.append('files', f));
//   return fetch(`${BASE_URL}/upload/gr`, { method: 'POST', body: formData }).then(handleResponse);
// };

// export const uploadIR = (files) => {
//   const formData = new FormData();
//   (Array.isArray(files) ? files : [files]).forEach((f) => formData.append('files', f));
//   return fetch(`${BASE_URL}/upload/ir`, { method: 'POST', body: formData }).then(handleResponse);
// };

// export const getGoodsReceipts = (params = {}) =>
//   fetch(`${BASE_URL}/goods-receipts${buildQs(params)}`).then(handleResponse);

// export const getInvoiceReceipts = (params = {}) =>
//   fetch(`${BASE_URL}/invoice-receipts${buildQs(params)}`).then(handleResponse);

// export const runReconciliation = (payload) =>
//   fetch(`${BASE_URL}/reconcile`, {
//     method: 'POST',
//     headers: { 'Content-Type': 'application/json' },
//     body: JSON.stringify(payload),
//   }).then(handleResponse);

// export const getReconciliations = (params = {}) =>
//   fetch(`${BASE_URL}/reconciliations${buildQs(params)}`).then(handleResponse);

// export const getReconciliationDetail = (id) =>
//   fetch(`${BASE_URL}/reconciliations/${id}`).then(handleResponse);

// export const exportReconciliation = (id, params = {}) => {
//   const qs = new URLSearchParams({
//     format: 'excel',
//     include_matched: 'true',
//     include_unmatched: 'true',
//     ...params,
//   }).toString();
//   window.location.href = `${BASE_URL}/reconciliations/${id}/export?${qs}`;
// };

// export const getUploadHistory = (params = {}) =>
//   fetch(`${BASE_URL}/uploads${buildQs(params)}`).then(handleResponse);

// const CHAT_URL = 'https://saviagent.savictech.com/sks/grir/api/v1/ai/chat';

// export const sendGRIRMessage = async (message, conversationHistory = []) => {
//   try {
//     const res = await fetch(CHAT_URL, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ message, conversation_history: conversationHistory }),
//     });
//     const data = await res.json();
//     return { success: true, response: data.response, conversation_history: data.conversation_history };
//   } catch (error) {
//     return { success: false, error: error.message || 'Failed to get response from AI', response: null, conversation_history: null };
//   }
// };



const BASE_URL = 'https://saviagent.savictech.com/sks/grir/api/v1/grir';
const AUTH_URL = 'https://saviagent.savictech.com/sks/grir/api/v1/auth/login';
const CHAT_URL = 'https://saviagent.savictech.com/sks/grir/api/v1/ai/chat';
const TOKEN_KEY = 'grir_sks_token';

async function fetchNewToken() {
  const res = await fetch(AUTH_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username: 'sks_client', password: 'Sks@Grir@2026' }),
  });
  if (!res.ok) throw new Error('SKS login failed');
  const data = await res.json();
  localStorage.setItem(TOKEN_KEY, data.access_token);
  return data.access_token;
}

async function getToken() {
  return localStorage.getItem(TOKEN_KEY) || fetchNewToken();
}

async function authFetch(url, options = {}) {
  const token = await getToken();
  const res = await fetch(url, {
    ...options,
    headers: { ...options.headers, Authorization: `Bearer ${token}` },
  });
  if (res.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
    const newToken = await fetchNewToken();
    return fetch(url, {
      ...options,
      headers: { ...options.headers, Authorization: `Bearer ${newToken}` },
    });
  }
  return res;
}

async function handleResponse(res) {
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const data = await res.json();
      if (Array.isArray(data.detail)) {
        detail = data.detail
          .map((e) => `[${Array.isArray(e.loc) ? e.loc.join(' → ') : e.loc}] ${e.msg}`)
          .join(' | ');
      } else if (typeof data.detail === 'string') {
        detail = data.detail;
      } else {
        detail = JSON.stringify(data);
      }
    } catch (_) {}
    throw new Error(detail);
  }
  return res.json();
}

function buildQs(params = {}) {
  const clean = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== '' && v !== undefined && v !== null)
  );
  const qs = new URLSearchParams(clean).toString();
  return qs ? '?' + qs : '';
}

export const getDashboard = () =>
  authFetch(`${BASE_URL}/dashboard`).then(handleResponse);

export const testSapConnection = () =>
  authFetch(`${BASE_URL}/sap/test-connection`).then(handleResponse);

export const sapSync = (payload) =>
  authFetch(`${BASE_URL}/sap-sync`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const uploadGR = (files) => {
  const formData = new FormData();
  (Array.isArray(files) ? files : [files]).forEach((f) => formData.append('files', f));
  return authFetch(`${BASE_URL}/upload/gr`, { method: 'POST', body: formData }).then(handleResponse);
};

export const uploadIR = (files) => {
  const formData = new FormData();
  (Array.isArray(files) ? files : [files]).forEach((f) => formData.append('files', f));
  return authFetch(`${BASE_URL}/upload/ir`, { method: 'POST', body: formData }).then(handleResponse);
};

export const getGoodsReceipts = (params = {}) =>
  authFetch(`${BASE_URL}/goods-receipts${buildQs(params)}`).then(handleResponse);

export const getInvoiceReceipts = (params = {}) =>
  authFetch(`${BASE_URL}/invoice-receipts${buildQs(params)}`).then(handleResponse);

export const runReconciliation = (payload) =>
  authFetch(`${BASE_URL}/reconcile`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).then(handleResponse);

export const getReconciliations = (params = {}) =>
  authFetch(`${BASE_URL}/reconciliations${buildQs(params)}`).then(handleResponse);

export const getReconciliationDetail = (id) =>
  authFetch(`${BASE_URL}/reconciliations/${id}`).then(handleResponse);

export const exportReconciliation = (id, params = {}) => {
  const qs = new URLSearchParams({
    format: 'excel',
    include_matched: 'true',
    include_unmatched: 'true',
    ...params,
  }).toString();
  getToken().then((token) => {
    const a = document.createElement('a');
    a.href = `${BASE_URL}/reconciliations/${id}/export?${qs}`;
    a.setAttribute('download', '');
    fetch(a.href, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => res.blob())
      .then((blob) => {
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  });
};

export const getUploadHistory = (params = {}) =>
  authFetch(`${BASE_URL}/uploads${buildQs(params)}`).then(handleResponse);

export const sendGRIRMessage = async (message, conversationHistory = []) => {
  try {
    const token = await getToken();
    const res = await fetch(CHAT_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ message, conversation_history: conversationHistory }),
    });
    const data = await res.json();
    return { success: true, response: data.response, conversation_history: data.conversation_history };
  } catch (error) {
    return { success: false, error: error.message || 'Failed to get response from AI', response: null, conversation_history: null };
  }
};
